import type { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import { ProductType } from '@evenfinancial/originator-client';
import type { PricingControlSummary } from '@evenfinancial/originator-client';

import { client } from '@portal/api-client/src/client';

import * as actions from './actions';
import { getPricingControlsAction } from './actions';

export function* getPricingControls() {
  try {
    const { data }: AxiosResponse<PricingControlSummary[]> = yield call(
      [client, 'get'],
      '/originator/pricingControls',
      {
        params: { limit: 100000, productType: ProductType.Loan },
      }
    );

    yield put(actions.getPricingControlsAction.success(data));
  } catch (err: any) {
    yield put(actions.getPricingControlsAction.failure(err));
  }
}

export function* pricingControlsSaga() {
  yield takeLatest(
    getType(getPricingControlsAction.request),
    getPricingControls
  );
}
